import { smoother } from "../../base/_gsap-core.js";
import {
   Carousel,
   Autoplay,
   Thumbs,
} from '../../base/_fancyapps.js';

document.addEventListener('DOMContentLoaded', () => {
   const carouselEl = document.querySelector('.post-related .carousel');

   if (carouselEl) {
      const carousel = new Carousel(carouselEl, {
         Autoplay: {
            timeout: 5000,
            autoStart: false,
         },
         Dots: {
            dynamicFrom: 5,
            minCount: 3,
         },
         Navigation: true,
         center: false,
         transition: 'classic',
         infinite: false,
      }, { Autoplay });
   }
});